import { useLocation } from 'react-router-dom';
import { wordpressBaseUrl } from '../../wordpressApiConfig/wordpressApiConfig';

const ErrorNotify = () => {
    const wpBaseUrl = wordpressBaseUrl();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const errorCode = searchParams.get('msg') || 'Something went wrong. Please try again later.';
    const readableMessage = errorCode || 'An unexpected error occurred.';

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: 'linear-gradient(to right, #f8f9fa, #e9ecef)',
        }}>
            <div style={{
                backgroundColor: '#fff',
                padding: '40px',
                borderRadius: '12px',
                boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
                maxWidth: '500px',
                width: '90%',
                textAlign: 'center',
            }}>
                <div style={{ fontSize: '48px', marginBottom: '20px' }}>😕</div>
                <h2 style={{ color: '#343a40', marginBottom: '10px' }}>Oops! Something went wrong.</h2>
                <p style={{ color: '#6c757d', marginBottom: '30px' }}>{readableMessage}</p>
                <button
                    onClick={() =>  window.location.href = `${wpBaseUrl}/home/`}
                    style={{
                        backgroundColor: '#007bff',
                        color: '#fff',
                        border: 'none',
                        padding: '12px 24px',
                        borderRadius: '8px',
                        fontSize: '16px',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s',
                    }}
                    onMouseOver={e => e.currentTarget.style.backgroundColor = '#0056b3'}
                    onMouseOut={e => e.currentTarget.style.backgroundColor = '#007bff'}
                >
                    Back to Home
                </button>
            </div>
        </div>
    );
};

export default ErrorNotify;
